// api/jobsApi.ts
import { baseApi } from "./BaseApi";
import { Job, CreateJobReq, UpdateJobAssignmentReq } from "../types/jobTypes";
import { Employee } from "../types/commonTypes";
import { DateTime } from "luxon";

interface ApiJob extends Omit<Job, "startTime"> {
  startTime: string;
}
const jobsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getJobs: builder.query<Job[], void>({
      query: () => `/jobs`,
      transformResponse: (response: ApiJob[]): Job[] => {
        return response.map((apiJob) => ({
          ...apiJob,
          startTime: DateTime.fromISO(apiJob.startTime, {
            zone: "utc",
          }).setZone("America/Los_Angeles"),
        }));
      },
    }),
    getJob: builder.query<Job, number>({
      query: (jobId) => `/jobs/${jobId}`,
      transformResponse: (response: ApiJob): Job => ({
        ...response,
        startTime: DateTime.fromISO(response.startTime, {
          zone: "utc",
        }).setZone("America/Los_Angeles"),
      }),
      providesTags: ["JobDetails"],
    }),
    getJobAssignedAgents: builder.query<Employee[], number>({
      query: (jobId) => `/jobs/${jobId}/agents`,
    }),
    createJob: builder.mutation<Job, CreateJobReq>({
      query: (req) => ({
        url: `/jobs`,
        method: "POST",
        body: req,
      }),
    }),
    updateJobAssignment: builder.mutation<
      void,
      { jobId: number; req: UpdateJobAssignmentReq }
    >({
      query: ({ jobId, req }) => ({
        url: `/jobs/${jobId}/assignments`,
        method: "PUT",
        body: req,
      }),
      invalidatesTags: ["JobDetails"],
    }),
  }),
});

export const {
  useGetJobsQuery,
  useCreateJobMutation,
  useGetJobQuery,
  useUpdateJobAssignmentMutation,
  useGetJobAssignedAgentsQuery,
} = jobsApi;

export default jobsApi;
